module.exports = __webpack_public_path__ + "static/img/5.da18ba2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/4/sp/5.png
// module id = Z6mD
// module chunks = 0